import React from 'react';

type StatusType =
  | 'in_stock' | 'low_stock' | 'out_of_stock' | 'electrified' | 'unelectrified'
  | 'pending_approval'| 'director_approved' | 'released' |'on_track' | 'watch' | 'investigate' | 'over_reported';

interface StatusBadgeProps {
  status: StatusType;
  className?: string;
  label?: string;
}

const statusConfig: Record<StatusType, { label: string; className: string }> = {
  in_stock: {
    label: 'In Stock',
    className: 'bg-[color:var(--status-green)]/10 text-status-green border border-[color:var(--status-green)]/20',
  },
  low_stock: {
    label: 'Low Stock',
    className: 'bg-[color:var(--status-amber)]/10 text-status-amber border border-[color:var(--status-amber)]/20',
  },
  out_of_stock: {
    label: 'Out of Stock',
    className: 'bg-[color:var(--status-red)]/10 text-status-red border border-[color:var(--status-red)]/20',
  },
  electrified: {
    label: 'Electrified',
    className: 'bg-[color:var(--status-green)]/10 text-status-green border border-[color:var(--status-green)]/20',
  },
  unelectrified: {
    label: 'Unelectrified',
    className: 'bg-[color:var(--status-red)]/10 text-status-red border border-[color:var(--status-red)]/20',
  },
  pending_approval: {
    label: 'Pending Approval',
    className: 'bg-[color:var(--status-amber)]/10 text-status-amber border border-[color:var(--status-amber)]/20',
  },
  director_approved: {
    label: 'Director Approved',
    className: 'bg-[color:var(--status-green)]/10 text-status-green border border-[color:var(--status-green)]/20',
  },
  released: {
    label: 'Released',
    className: 'bg-[color:var(--status-green)]/10 text-status-green border border-[color:var(--status-green)]/20',
  },
  on_track: {
    label: 'On Track',
    className: 'bg-[color:var(--status-green)]/10 text-status-green border border-[color:var(--status-green)]/20',
  },
  watch: {
    label: 'Watch',
    className: 'bg-[color:var(--status-amber)]/10 text-status-amber border border-[color:var(--status-amber)]/20',
  },
  investigate: {
    label: 'Investigate',
    className: 'bg-[color:var(--status-red)]/10 text-status-red border border-[color:var(--status-red)]/20',
  },
  over_reported: {
    label: 'Over-Reported',
    className: 'bg-[color:var(--geo)]/10 text-[color:var(--geo)] border border-[color:var(--geo)]/20',
  },
};

export default function StatusBadge({ status, className = '', label }: StatusBadgeProps) {
  const config = statusConfig[status];
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${config.className} ${className}`}
    >
      {label !== undefined ? label : config.label}
    </span>
  );
}